import angular from 'angular';
import moment from 'moment';
import * as R from 'ramda';

export default function SelectAdvisoryReportParametersDialogController(
  $rootScope,
  $scope,
  $q,
  $filter,
  ssDialogService,
  loaderService,
  reportsDataService,
  alerts,
  selectAdvisoryReportTypesDialog,
) {
  const vm = this;

  vm.appIsLoaded = false;

  vm.reportTypes = [];
  
  vm.handleParameterChange = _handleParameterChange;

  vm.handleGoBack = _handleGoBack;
  vm.handleSubmit = _handleSubmit;
  vm.handleCloseDialog = _handleCloseDialog;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    return _getReportTypes().then(() => {
      initializeDefaultParameters();
      initializeSubmittedParameters();
      vm.appIsLoaded = true;
    });
  }

  function _getReportTypes() {
    loaderService.showViewLoader = true;
    
    if (vm.editMode === 1) {
      // Get all the report types for the package
      return reportsDataService.getReportParameterReportTypesByReportPackage(vm.reportPackageId, 2, true).then(response => {  
        vm.reportTypes = response.data.result;    
        loaderService.showViewLoader = false;
      });
    } else {      
      // Get the selected report type 
      return reportsDataService.getReportParameterReportType(vm.reportPackageConfiguration.reportPackageReportId, true).then(response => {  
        vm.reportTypes = [];
        vm.reportTypes.push(response.data);    
        loaderService.showViewLoader = false;
      });
    }
  }

  function initializeDefaultParameters() {
    angular.forEach(vm.reportTypes, (reportType) => {
      
      if ((reportType.renderFormatList !== null) && (reportType.renderFormatList.length > 0))
      {
        angular.forEach(reportType.renderFormatList, (renderFormat) => {
          if (renderFormat == "PDF") {
              reportType.renderFormatPDF = true;
          } else if (renderFormat == "EXCEL") {
              reportType.renderFormatExcel = true;
          } else if (renderFormat == "WORD") {
              reportType.renderFormatWord = true;
          } 
        });
      }

      if (reportType.report.scheduleParameters) {
        angular.forEach(reportType.report.scheduleParameters, (scheduleParameter) => {

          if (scheduleParameter.isMultiSelect) {
            if ((scheduleParameter.dependantUponId !== null) && (scheduleParameter.dependantUponId > 0)) {
              // We have to get the value of the parameter this one is dependant upon
              angular.forEach(reportType.report.scheduleParameters, (reportScheduleParameter) => {
                if (reportScheduleParameter.scheduleParameterId == scheduleParameter.dependantUponId) {
                  angular.forEach(reportType.submissionParameters, (submittedParameter) => {
                    if (submittedParameter.parameterName == reportScheduleParameter.parameterName) {
                      _populateDependantParameter(reportType, reportType.reportGroupId, scheduleParameter.scheduleParameterId, submittedParameter.parameterValue);
                    }
                  });
                }
              });
            }
          }

          /*
          if (scheduleParameter.isDateTime) {
            const paramValue = vm.schedule.schedule[`parameter${currentScheduleParam.scheduleParameterId}Value`];
            if ((paramValue !== null) && (paramValue !== undefined)) {
              const arr = paramValue.split(',');
              vm.schedule.schedule[`parameter${currentScheduleParam.scheduleParameterId}Value`] = arr;
            }
          }
          */

          if (scheduleParameter.isNumeric) {
            const paramValue = Number(scheduleParameter.defaultValue);
            reportType[`${reportType.reportGroupId}parameter${scheduleParameter.scheduleParameterId}Value`] = paramValue;
          }
        });
      }
    });
  }

  function initializeSubmittedParameters() {
    angular.forEach(vm.reportTypes, (reportType) => {
      if (reportType.report.scheduleParameters) {
        angular.forEach(reportType.report.scheduleParameters, (scheduleParameter) => {
          angular.forEach(reportType.submissionParameters, (submissionParameter) => {
            
            if (!scheduleParameter.isDateTime && !scheduleParameter.isMultiSelect&& !scheduleParameter.isNumeric) {
              if (scheduleParameter.parameterName === submissionParameter.parameterName) {
                scheduleParameter.userValue = submissionParameter.parameterValue;
              }
            }

            if (scheduleParameter.isMultiSelect) {
              if (scheduleParameter.parameterName === submissionParameter.parameterName) {
                const paramValue = submissionParameter.parameterValue;
                if ((paramValue !== null) && (paramValue !== undefined)) {
                  const arr = paramValue.split(',');
                  reportType[`${reportType.reportGroupId}parameter${scheduleParameter.scheduleParameterId}Value`] = arr;
                }
              }
            }

            if (scheduleParameter.isDateTime) {
              const paramValue = vm.schedule.schedule[`parameter${currentScheduleParam.scheduleParameterId}Value`];
              if ((paramValue !== null) && (paramValue !== undefined)) {
                const arr = paramValue.split(',');
                vm.schedule.schedule[`parameter${currentScheduleParam.scheduleParameterId}Value`] = arr;
              }
            }

            if (scheduleParameter.isNumeric) {
              if (scheduleParameter.parameterName === submissionParameter.parameterName) {
                const paramValue = submissionParameter.parameterValue;
                if ((paramValue !== null) && (paramValue !== undefined)) {
                  reportType[`${reportType.reportGroupId}parameter${scheduleParameter.scheduleParameterId}Value`] = Number(paramValue);
                }
              }
            }
          });
        });
      }
    });
  }

  function _handleParameterChange(parameter) {
    const reportType = R.find(R.propEq('reportGroupId', parameter.reportGroupId), vm.reportTypes);
    const filterValue = _getUserValue(reportType, parameter);

    if (reportType.report.scheduleParameters !== null && reportType.report.scheduleParameters !== undefined) {
      const paramsToUpdate = R.find(R.propEq('dependantUponId', parameter.scheduleParameterId), reportType.report.scheduleParameters);

      if (paramsToUpdate !== null && paramsToUpdate !== undefined) {
        _populateDependantParameter(reportType, parameter.reportGroupId, paramsToUpdate.scheduleParameterId, filterValue);
      }
    }
  }

  function _populateDependantParameter(reportType, reportGroupId, scheduleParameterId, filterValue) {
    loaderService.showViewLoader = true;
    reportsDataService.getDependantScheduleValues(reportGroupId, scheduleParameterId, filterValue).then(response => {
      const retParam = response.data;
      reportType.report.scheduleParameters.forEach(param => {
        if (param.scheduleParameterId === retParam.scheduleParameterId) {
          param.scheduleParameterValues = retParam.scheduleParameterValues;
          param.userValue = '';
          const selectedValuesObj = reportType;
          if (selectedValuesObj !== null && selectedValuesObj !== undefined) {
            const paramSelectedValuesObj = reportType[`${reportType.reportGroupId}parameter${param.scheduleParameterId}Value`];
            if (paramSelectedValuesObj !== null && paramSelectedValuesObj !== undefined) {
              reportType[`${reportType.reportGroupId}parameter${param.scheduleParameterId}Value`] = '';
            }
          }
        }
      });
      loaderService.showViewLoader = false;
    });
  }

  function _handleGoBack($event) {
    ssDialogService.hide(ssDialogService.dialogs.reports.selectAdvisoryReportParameters);

    ssDialogService.dialogs.reports.selectAdvisoryReportTypesDialog = ssDialogService.alert(
        selectAdvisoryReportTypesDialog.getOptions($event, {
          hasAdvisoryServices: vm.hasAdvisoryServices,
          reportPackage: vm.reportPackage,
        }),
      );
      return ssDialogService.show(ssDialogService.dialogs.reports.selectAdvisoryReportTypesDialog);
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.selectAdvisoryReportParametersDialog);
  }

  /** ********************************************
   * Private Functions
   */

  function _handleSubmit($event) {
    angular.forEach(vm.reportTypes, (reportType, index) => {
      const reportParameters = _getReportParametersFromUI(reportType);
      reportType.parameters = reportParameters;

      let renderFormat = "";

      if (reportType.renderFormatPDF) {
        if (renderFormat === "") {
            renderFormat = "PDF";
          } else {
            renderFormat = renderFormat + ",PDF";
          }
      } 
      
      if (reportType.renderFormatExcel) {
        if (renderFormat === "") {
          renderFormat = "EXCEL";
        } else {
          renderFormat = renderFormat + ",EXCEL";
        }
      } 
      
      if (reportType.renderFormatWord) {
        if (renderFormat === "") {
          renderFormat = "WORD";
        } else {
          renderFormat = renderFormat + ",WORD";
        }
      } 

      reportType.renderFormat = renderFormat;
    });

    // Save the report types and update the main list. 
    _saveReportParameters(vm.reportPackageId, vm.reportTypes).then(() => {
      $scope.prSelectAdvisoryReportParametersForm.$submitted = false;
      switch (vm.saveType) {
        case 'saveAndClose':
          alerts.success('The report parameters have been saved successfully.');
          _handleCloseDialog();
          break;
        case 'save':
          alerts.success('The report parameters have been saved successfully.');
          break;
        default:
          break;
      }
    });
  }
  
  function _getReportParametersFromUI(reportType) {
    const uiReportParameters = reportType.report.scheduleParameters;
    const hasNoSubmittedParameters = R.isEmpty(uiReportParameters) || R.isNil(uiReportParameters);

    if (hasNoSubmittedParameters) {
      return uiReportParameters;
    }

    uiReportParameters.forEach(param => {
      if (param.parameterName === 'ATCustID') {
        param.userValue = vm.atCustId;
      }
    });

    return R.map(
      parameter => ({
        parameterName: parameter.parameterName,
        parameterValue: _getUserValue(reportType, parameter),
        parameterLabel: _getUserLabel(reportType, parameter),
      }),
      uiReportParameters,
    );
  }
  
  function _getUserValue(reportType, parameter) {
    if (parameter.parameterDataType === 'int') {
      let retVal = null;
      if (parameter.userValue !== undefined) {
        retVal = parameter.userValue;
      }
      return retVal;
    }

    // Dropdown
    if (parameter.parameterDataType === 'varchar') {
      let retVal = null;
      if (parameter.userValue !== undefined) {
        retVal = parameter.userValue;
      }
      return retVal;
    }

    // Datetime
    if (parameter.parameterDataType === 'datetime') {
      let retVal = null;
      if (parameter.userValue !== undefined) {
        retVal = moment(parameter.userValue).format('MM/DD/YYYY');
      }
      return retVal;
    }

    // Multiselect
    if (parameter.parameterDataType === 'multiselect') {
      const values = reportType[`${parameter.reportGroupId}parameter${parameter.scheduleParameterId}Value`];
      if (values.includes('All') === true) {
        return 'All';
      }
      return values.join();
    }

    // Numeric
    if (parameter.parameterDataType === 'numeric') {
      let retVal = null;
      const value = reportType[`${parameter.reportGroupId}parameter${parameter.scheduleParameterId}Value`];
      if (value !== undefined) {
        retVal = value + "";
      }
      return retVal;
    }

    return parameter.userValue;
  }
  
  function _getUserLabel(reportType, parameter) {
    if (parameter.parameterDataType === 'int') {
      let retVal = null;
      if (parameter.userValue !== undefined) {
        retVal = parameter.userValue;
      }
      return retVal;
    }

    // Dropdown
    if (parameter.parameterDataType === 'varchar') {
      let retVal = '';  
      const selectedValue = parameter.userValue;   
      
      if ((selectedValue !== undefined)) {
        angular.forEach(reportType.report.scheduleParameters, (scheduleParameter) => {
          if (scheduleParameter.scheduleParameterId === parameter.scheduleParameterId) {
            angular.forEach(scheduleParameter.scheduleParameterValues, (scheduleParameterValue) => {
              if (scheduleParameterValue.parameterValue === selectedValue) {
                retVal = scheduleParameterValue.parameterLabel;
              }
            });
          }
        });
      }
      return retVal;
    }

    // Datetime
    if (parameter.parameterDataType === 'datetime') {
      let retVal = null;
      if (parameter.userValue !== undefined) {
        retVal = moment(parameter.userValue).format('MM/DD/YYYY');
      }
      return retVal;
    }

    // Multiselect
    if (parameter.parameterDataType === 'multiselect') {
      let values = [];
      const selectedValues = reportType[`${parameter.reportGroupId}parameter${parameter.scheduleParameterId}Value`];
      
      if ((selectedValues !== undefined) && (selectedValues.length > 0)) {
        angular.forEach(reportType.report.scheduleParameters, (scheduleParameter) => {
          if (scheduleParameter.scheduleParameterId === parameter.scheduleParameterId) {
            angular.forEach(scheduleParameter.scheduleParameterValues, (scheduleParameterValue) => {
              angular.forEach(selectedValues, (selectedValue) => {
              if (scheduleParameterValue.parameterValue === selectedValue) {
                values.push(scheduleParameterValue.parameterLabel);
              }
            });
            });
          }
        });

        if (values.includes('All') === true) {
          return 'All';
        }
      }
      
      return values.join();
    }

    // Numeric
    if (parameter.parameterDataType === 'numeric') {
      let retVal = null;
      const value = reportType[`${parameter.reportGroupId}parameter${parameter.scheduleParameterId}Value`];
      if (value !== undefined) {
        retVal = value + "";
      }
      return retVal;
    }

    return parameter.userValue;
  }
  
  function _saveReportParameters(reportPackageId, reportTypes) {
    loaderService.showViewLoader = true;
    const dfdSave = $q.defer();

    if ((reportPackageId !== null) && (reportPackageId > 0)) {
      reportsDataService.saveBulkReportParameterReportParameters(reportPackageId, reportTypes).then((response) => {
        const savedReportParameters = response.data;
        if (savedReportParameters === 'undefined' || savedReportParameters === false) {
          // There was an error saving the Report Parameter information
          alerts.error('Error occurred while saving the Report Package Report Parameters.');
          loaderService.showViewLoader = false;
          dfdSave.reject();
        } else {
          // The Report Package Report Parameter information has been saved
          alerts.success('The Report Parameters have been saved successfully. These will be used to generate the reports when the package is generated.');          
          $rootScope.$broadcast('refreshReportPackageSummary', {
            reportPackageId: Number(reportPackageId)
          });          

          if (reportTypes !== null)
          {
            let reportGroupIds = [];

            angular.forEach(reportTypes, (reportType) => {
              reportGroupIds.push(reportType.reportGroupId);
            });

            $rootScope.$broadcast('refreshReportPackageSummaryParameters', {
              reportPackageId,
              reportGroupIds,
            });
          }

          loaderService.showViewLoader = false;
          dfdSave.resolve();
        }
      });
    } else {
      loaderService.showViewLoader = false;
      dfdSave.reject();
    }

    return dfdSave.promise;
  }
}

SelectAdvisoryReportParametersDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  'ssDialogService',
  'loaderService',
  'reportsDataService',
  'alerts',
  'selectAdvisoryReportTypesDialog',
];
